<template>
  <div class="agreement-step" data-testid="agreement-step">
    <p class="step-eyebrow">{{ $t("billing.agreement.eyebrow") }}</p>
    <h2 class="font-serif mb-2">{{ $t("billing.agreement.title") }}</h2>
    <p class="text-body-secondary mb-4">
      <i18n-t
        keypath="dashboard.buyer.platform_agreement_clickwrap_intro"
        scope="global"
      >
        <template #link>
          <a
            href="https://soldera.org/terms"
            target="_blank"
            rel="noopener noreferrer"
            class="agreement-link"
          >
            {{ $t("dashboard.buyer.platform_agreement_link_text") }}
          </a>
        </template>
      </i18n-t>
    </p>

    <div
      class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3"
    >
      <div class="form-check mb-0">
        <input
          :id="checkboxId"
          v-model="agreed"
          class="form-check-input"
          type="checkbox"
          data-testid="agreement-checkbox"
        />
        <label class="form-check-label" :for="checkboxId">
          {{ $t("dashboard.buyer.agree_to_terms") }}
        </label>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-lg px-5"
        :disabled="!agreed || loading"
        data-testid="agreement-accept"
        @click="$emit('accept')"
      >
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        {{ $t("common.actions.accept") }}
        <FontAwesomeIcon v-if="!loading" icon="arrow-right" class="ms-2" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useId } from "vue";

withDefaults(defineProps<{ loading?: boolean }>(), { loading: false });

defineEmits<{
  accept: [];
}>();

const checkboxId = useId();
// Pre-ticked: the clickwrap is the Accept button; the box only lets someone stop to read first.
const agreed = ref(true);
</script>

<style scoped lang="scss">
.step-eyebrow {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--phoenix-primary);
  margin-bottom: 0.25rem;
}

.agreement-link {
  font-weight: 600;
  color: var(--phoenix-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
